import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, Grid, Paper, Typography } from '@mui/material';
import axios from 'axios';
import { API } from '../controller/api';
import logo from '../assets/images/aiforhrhub.png'

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    try {
      const response = await axios.post(`${API}/auth/forgot-password`, { email });
      setMessage('If an account with that email exists, a reset link has been sent to your email. You may want to check your spam mail.');
    } catch (error) {
      setMessage('Error sending reset link. Please try again later.');
    }
  };

  return (
    <Grid 
      container 
      spacing={0} 
      direction="column" 
      alignItems="center" 
      justifyContent="center" 
      style={{ minHeight: '100vh', backgroundColor: '#074B79' }}
    >
      <Grid item xs={12}>
        <Paper 
          elevation={3} 
          style={{ padding: '2rem', textAlign: 'center', maxWidth: 350, backgroundColor: 'white' }}
        >
            <img 
            src={logo} // Logo placeholder
            alt="Logo"
            style={{ marginBottom: '1rem', width:200 }}
          />
          <Typography variant="h6" gutterBottom>
            Forgot Password
          </Typography>
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button 
            variant="contained" 
            fullWidth 
            onClick={handleForgotPassword}
            style={{ backgroundColor: '#0077B6', color: 'white', marginTop: '1rem' }}
          >
            Send Reset Link
          </Button>
          {message && (
            <Typography variant="body2" style={{ color: '#0077B6', marginTop: '1rem' }}>
              {message}
            </Typography>
          )}
          <Button 
            variant="text" 
            fullWidth 
            onClick={() => navigate('/login')}
            style={{ color: '#0077B6', marginTop: '1rem' }}
          >
            Back to Login
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
